/* eslint-disable global-require */
import 'whatwg-fetch';
import { setPhoneNumber, getPhoneNumber, getAuthToken, isAuthenticated, removeAuthToken } from './authHelpers.js';
import {formatCartForSend} from './formatCartRes.js';
import _ from 'lodash';
const baseApiUrl = process.env.BASE_API;

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    if(response.status==401) {
      removeAuthToken();
      window.location.href = '/';
    }

    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}
export function makeCall({ url, action, method, body, doNotSetContentType }) {
  let headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${getAuthToken()}`
  };
  if (!doNotSetContentType) {
    headers['Content-Type'] = 'application/json';
  }
  let fetchOpts = {
    method,
    headers,
    body
  };
  return fetch(url || `${baseApiUrl}${action}`, fetchOpts)
    .then(checkStatus)
      .then((success) => success.json());
}

// export function getUserLocation(){
//     let headers = {
//         Accept: 'application/json'
//     };
//     headers['Content-Type'] = 'application/json';
//     let method = 'GET';
//     let mode = 'no-cors';
//     let url = 'https://geoip-db.com/json/';

//     let fetchOpts = {
//       method,
//       headers,
//       mode
//     };
// }

export function fetchSearchResults(searchQuery) {
    return makeCall({
        method: 'GET',
        action: searchQuery
    });
}

export function selectLocationByPartnerId(partnerId, partnerLocations){
  let partnerLocs = [...partnerLocations];
  for (let i in partnerLocs) {
    if(+partnerLocs[i].partnerId == +partnerId){
      partnerLocs[i] = { ...partnerLocs[i], chosenPVZ: true };
    }
    else{
      partnerLocs[i] = { ...partnerLocs[i], chosenPVZ: false };
    }
  }

  return partnerLocs;
}

export function updatePartnerLocationsWithPrice(searchRes, partnerLocations){
  let locationsPrices = searchRes.locationsPrices;
  let partnerLocs = [...partnerLocations];
  let bestLocationId = searchRes.bestLocationPrice.locationId;

  for (let j in partnerLocs) {
    partnerLocs[j] = { ...partnerLocs[j], price: '' };
    for (let i in locationsPrices) {
      if (+partnerLocs[j].partnerLocationId == +bestLocationId) {
        partnerLocs[j] = { ...partnerLocs[j], bestPrice: true };
      }
      if (+partnerLocs[j].partnerLocationId == +locationsPrices[i].locationId) {
        partnerLocs[j] = { ...partnerLocs[j], price: locationsPrices[i].price };
        break;
      }
    }
  }

  return partnerLocs;
}

export function clearPriceFromPartnerLocations(partnerLocations){
  let partnerLocs = [...partnerLocations];
  for (let j in partnerLocs) {
    partnerLocs[j] = { ...partnerLocs[j], price: '' };
  }

  return partnerLocs;
}

export function sendNumberForRegistration(number, refId) {
  setPhoneNumber(number);
  if(refId) {
    return makeCall({
      method: 'POST',
      action: `account/register?refId=${refId}`,
      body: JSON.stringify({
        phone: number
      })
    });
  }
  else {
    return makeCall({
      method: 'POST',
      action: 'account/register',
      body: JSON.stringify({
        phone: number
      })
    });
  }
}

export function logIn({password, phone = getPhoneNumber()}) {
  return makeCall({
    method: 'POST',
    action: 'account/login',
    body: JSON.stringify({
      phone,
      pswdHash: password
    })
  });
}

export function authorizeWithSoc(session) {
  return makeCall({
    method: 'POST',
    action: 'account/loginbysocialdata',
    body: JSON.stringify(session)
  });
}

export function registerWithSoc(session, refId) {
  if(refId) {
    return makeCall({
      method: 'POST',
      action: `account/registerbysocialdata?refId=${refId}`,
      body: JSON.stringify(session)
    });
  }
  else {
    return makeCall({
      method: 'POST',
      action: 'account/registerbysocialdata',
      body: JSON.stringify(session)
    });
  }
}

export function resetPassword(phone) {
  return makeCall({
    method: 'POST',
    action: 'account/resetpassword',
    body: JSON.stringify({phone})
  });
}

export function changePassword(currentPasswordHash, newPasswordHash) {
  return makeCall({
    method: 'POST',
    action: 'account/changepassword',
    body: JSON.stringify({
      pswdHash: currentPasswordHash,
      newPswdHash: newPasswordHash
    })
  });
}

export function reverseGeocode({lat, lon}) {
  const {geocoderKey, geocoderZoom} = require('src/config').default;
  const url = `http://locationiq.org/v1/reverse.php?format=json&key=${geocoderKey}&lat=${lat}&lon=${lon}&zoom=${geocoderZoom}&accept-language=ru`;
  return makeCall({
    method: 'GET',
    url
  });
}

export function fetchCart() {
    if (isAuthenticated())
    {
        return makeCall({
            method: 'GET',
            action: 'cart'
        });
    }
    else {
        return new Promise((res) => res(getCartFromLocaleStorage()));
    }
}

// TODO: to cartHelper or something similar
export function getCartFromLocaleStorage() {
    return JSON.parse(localStorage.getItem('cart'));
}

export function setCartToLocaleStorage(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
    return 'success';
}

export function removeCartFromLocaleStorage() {
    localStorage.removeItem('cart');
}

export function removeCartFromStorage(actionCartDetailId, cartItems) {
    if (isAuthenticated()) {
        ///let cartItemsToRemove = _.filter(cartItems, (el) => +el.CartDetailId === +actionCartDetailId);

        return makeCall({
            method: 'DELETE',
            action: 'cart',
            body: JSON.stringify({
              cartId: actionCartDetailId
            })
        });
    }
    else {
        let cart = _.filter(cartItems, (el) => +el.CartDetailId !== +actionCartDetailId);

        return new Promise((res) => res(setCartToLocaleStorage(cart)));
    }
}

export const changeCartProperty = (propertyToChange, cartId, cartItems) => {
    let updatedCartDetails = _.filter(cartItems, (el) => +el.CartId === +cartId);
    let updatedCartDetail;

    if (propertyToChange.newQuantity) {
        updatedCartDetail = [{ ...updatedCartDetails[0], Quantity: propertyToChange.newQuantity }];
    }
    else if (propertyToChange.text) {
        updatedCartDetail = [{ ...updatedCartDetails[0], Comment: propertyToChange.text }];
    }

    if (isAuthenticated()) {
        return makeCall({
            method: 'POST',
            action: 'cart',
            body: JSON.stringify(formatCartForSend(updatedCartDetail))
        });
    }
    else {
        let index = _.indexOf(cartItems, _.find(cartItems, { CartId: cartId }));
        let resultCartItems = getCartFromLocaleStorage();
        resultCartItems.splice(index, 1, updatedCartDetail[0]);

        return new Promise(res => res(setCartToLocaleStorage(resultCartItems)) );
    }
};

export function removeCartItemsFromState(actionCartDetailId, cartItems) {
    return _.filter(cartItems, (el) => +el.CartDetailId !== +actionCartDetailId);
}

export function updateCartFromLocaleStorage() {
  if (isAuthenticated()) {
    const cartFromStorage = getCartFromLocaleStorage();
    if (cartFromStorage) {
      let cart = cartFromStorage.map(cartDetail => {
        cartDetail.CartDetailId = 0;
        return cartDetail;
      });
      removeCartFromLocaleStorage();
      // TODO: need to show update error exception or to do nothing?
      makeCall({
        method: 'POST',
        action: 'cart',
        body: JSON.stringify(formatCartForSend(cart))
      });
    }
  }
}

export function checkoutCart() {
    return makeCall({
        method: 'GET',
        action: 'checkout'
    });
}

export function placeInmotions() {
    return makeCall({
      method: 'GET',
      action: 'checkout/placeinmotions'
    });
}

export function sendSearchRequest({latitude, longitude, detailNum, partnerId}) {
  if(+partnerId){
    return makeCall({
      method: 'GET',
      action: `search?detailNum=${detailNum}&partnerId=${partnerId}`
    });
  }
  else{
    return makeCall({
      method: 'GET',
      action: `search?detailNum=${detailNum}&latitude=${latitude}&longitude=${longitude}`
    });
  }
}

export function addNewItemToCart(cartDetail){
  if (isAuthenticated()) {
    cartDetail.CartDetailId = 0;
    return makeCall({
            method: 'POST',
            action: 'cart',
            body: JSON.stringify(formatCartForSend([cartDetail]))
          });
  } else {
    let cartDetails = getCartFromLocaleStorage();
    if (cartDetails) {
      cartDetails = [...cartDetails, cartDetail];
      return new Promise((res) => res(setCartToLocaleStorage(cartDetails)));
    }
    else{
      return new Promise((res) => res(setCartToLocaleStorage([cartDetail])));
    }
  }
}

// TODO: To Tocartpopuphelper
export function getPartnerId() {
  return localStorage.getItem('data-partnerid');
}

export function setPartnerId(partnerId) {
  if(+partnerId) {
    localStorage.setItem('data-partnerid', partnerId);
  }
}

export const requestChangePhoneCode = (newPhone) => {
    return makeCall({
        method: 'POST',
        action: 'changephone/requestcode',
        body: JSON.stringify(newPhone)
    });
};

export const requestChangePhoneCodeValid = (codeHash) => {
  return makeCall({
    method: 'POST',
    action: 'changephone/validatecode',
    body: JSON.stringify(codeHash)
  });
};

export const exportUserOrdersToXlsx = (orders) => {
  let headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${getAuthToken()}`
  };

  headers['Content-Type'] = 'application/json';

  const method = 'POST';
  const body = JSON.stringify(orders);

  let fetchOpts = {
    method,
    headers,
    body
  };

  return fetch(`${baseApiUrl}${'order/xlsx'}`, fetchOpts);
};



/** WEBPACK FOOTER **
 ** ./src/logic/api.js
 **/